import { createFileRoute } from "@tanstack/react-router";
import { ResetPasswordScreen } from "@modules/password-reset/views";

interface ResetPasswordSearch {
  /** The one-time token of the emailed link. Absent renders the "no usable link" state. */
  token?: string;
}

/**
 * `/reset-password`: the landing path of the « Choisissez un nouveau mot de passe » email. The
 * backend builds the link as `{IDENTITY_PUBLIC_BASE_URL}/reset-password?token=...`, so this route
 * has to match it. PUBLIC: no guard, the person is signed out.
 */
export const Route = createFileRoute("/reset-password")({
  validateSearch: (search: Record<string, unknown>): ResetPasswordSearch => ({
    token: typeof search.token === "string" ? search.token : undefined,
  }),
  component: ResetPasswordRoute,
});

function ResetPasswordRoute() {
  const { token } = Route.useSearch();
  return <ResetPasswordScreen tokenFromUrl={token} />;
}
